<template>
  <article>
    <div class="filter">
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">订单ID：</div>
        <el-input v-model="filters.orderid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">列表ID：</div>
        <el-input v-model="filters.oids" placeholder="多个ID用,分割" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker
            v-model="filters.dateTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions" size='small'>
          </el-date-picker>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <button class="blue-small-btn" @click="moreDisplay = !moreDisplay">更多</button>
      <div class="ml-auto">
        <router-link class="blue-small-btn mr-10" :to="{path: '/adOrderEdit', query: {oid: 0}}">新建</router-link>
      </div>
    </div>
    <div class="filter mt-10">
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.uid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">购买类型：</div>
        <el-select class="filter__input" size="mini" v-model="filters.purchase">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in purchaseList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">跟单人：</div>
        <el-select class="filter__input" size="medium" v-model="filters.opids"  multiple collapse-tags>
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists.slice(1)" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">备注：</div>
        <el-input v-model="filters.remark" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <!--
      <div class="filter__item" v-if="moreDisplay">
        <div class="filter__name">口令墙：</div>
        <watchSelect v-model="filters.awid" :lists.sync="watchwordLists"/>
      </div>
      -->
      <div class="filter__item">
        <div class="filter__name">任务墙：</div>
        <taskSelect v-model="filters.etid" :lists.sync="taskLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">付款金额：</div>
        <input class="payment_range" type="text" v-model="filters.min_payment"/>
        <div>-</div>
        <input class="payment_range" type="text" v-model="filters.max_payment"/>
      </div>
    </div>
    <div class="flex jcs mt-20" v-if="moreDisplay">
      <button class="blue-small-btn" @click="download(1)">导出订单表格</button>
      <button class="blue-small-btn ml-10" @click="download(5)">导出预售截图</button>
      <button class="blue-small-btn ml-10" @click="download(2)">导出报单截图</button>
      <button class="blue-small-btn ml-10" @click="download(3)">导出完成截图</button>
      <button class="blue-small-btn ml-10" @click="download(4)">导出对账订单表格</button>
      <button class="blue-small-btn ml-10" @click="download(6)">导出马赛克报单截图</button>
      <button class="blue-small-btn ml-10" @click="download(7)">导出马赛克完成截图</button>
    </div>
    <div class="flex jcs mt-20" v-if="moreDisplay">
      <div class="filter__item">
        <div class="filter__name">第三方：</div>
        <chnDockingSelect v-model="filters.cdid" />
      </div>
      <div class="filter__item">
        <div class="filter__name">对接状态：</div>
        <dockingStatusSelect v-model="filters.docking_status" :need-filter="true" />
      </div>
      <div class="filter__item">
        <div class="filter__name">AI审核状态：</div>
        <aiReviewSelect v-model="filters.ai_review_status" :need-filter="true" />
      </div>
      <div class="filter__item">
        <div class="filter__name">屏蔽用户ID：</div>
        <el-input v-model="filters.invalid_uid_lists" placeholder="多个ID用,分割" size="mini" class="filter__input"></el-input>
      </div>
    </div>
    <div class="flex jcb mt-20">
      <div class="">
        <el-button size="mini" @click="toggleSelection(lists)">全选</el-button>
        <el-button size="mini" @click="toggleSelection()">取消选择</el-button>
        <el-button type="primary" plain size="mini" @click="editMultiReviseOrder">批量修改</el-button>
        <el-button size="mini" @click="multiReceiveDialog = !multiReceiveDialog">上传收款信息</el-button>
      </div>
      <div class="flex jce">
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in statusList" :key="index" @click="changeStatus(index)">{{item.name}}</button>
      </div>
    </div>
    <div class="flex jce mt-20" v-if="filters.status == 0 || filters.status == 1 || filters.status == 2 || filters.status == 3 ||filters.status == 7">
      <div class="mt-5">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" v-if="reviseSelect">全选</el-checkbox>
      </div>
      <button class="ml-10" :class="{'blue-small-btn': reviseSelect, 'white-small-btn': !reviseSelect}"  @click="changeMulti" v-if="filters.status == 2">一键修改</button>
      <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in handleList" :key="index" @click="changeHandle(index)" v-if="!reviseSelect">{{item.name}}</button>
      <el-button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in handleList" :key="item" @click="changeHandle(index)" disabled v-if="reviseSelect">{{item.name}}</el-button>
      <button class="blue-small-btn ml-10" @click="adOrderUpdate">提交</button>
    </div>
    <!-- 表格 -->
    <el-table
      ref="dataTable"
      :data="lists"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      class="mt-20"
      height="600"
      :summary-method="getSummaries"
      show-summary
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="30" align="center"></el-table-column>

      <!-- 动态列：prop → columnName -->
      <el-table-column
        v-for="(col, index) in tableColumns"
        :key="`${col.columnName}-${index}`"
        :prop="col.columnName"
        :label="col.columnTitle"
        :width="col.width"
        align="center"
        v-if="col.isShow"
      >
        <!-- 表头双击设置 -->
        <template slot="header" slot-scope="scope">
          <span @dblclick="isShowColumn = true">
            <i v-if="index === 0" class="el-icon-setting" style="cursor:pointer;margin-right:4px" @click="isShowColumn = true"></i>
            {{ col.columnTitle }}
          </span>
        </template>

        <!-- 内容渲染 -->
        <template slot-scope="scope">
          <div v-if="col.columnName === 'oid'">
            <router-link :to="{path: '/adOrderEdit', query: {oid: scope.row.oid}}" target='_blank'>{{scope.row.oid}}</router-link>
          </div>
          <div v-else-if="col.columnName === 'adid'" @dblclick="setFiltersValue('adid', scope.row.adid)">
            {{scope.row.title}}({{scope.row.adid}})
          </div>

          <div v-else-if="col.columnName === 'uid'" @dblclick="setFiltersValue('uid', scope.row.uid)">
            {{scope.row.username}}({{scope.row.uid}})
          </div>

          <div v-else-if="col.columnName === 'payment'">
            <div @click="editOrder(scope.$index)">
              {{scope.row.payment}}<i class="el-icon-edit"></i>
            </div>
          </div>

          <div v-else-if="['min_discount','discount','user_discount'].includes(col.columnName)">
            <span>{{scope.row[col.columnName]}}%</span>
          </div>
          <div v-else-if="['presale_img', 'payment_img', 'finish_img','mosaic_payment','mosaic_finish'].includes(col.columnName)">
            <div v-if="scope.row[col.columnName]" @click="previewURL(scope.row.oid,
              col.columnName === 'presale_img' ? 7 :
              col.columnName === 'payment_img' ? 0 :
              col.columnName === 'finish_img' ? 2 :
              col.columnName === 'mosaic_payment' ? 3 : 4
            )">
              <img :src="scope.row[col.columnName]" style="width:40px;height:50px" />
            </div>
          </div>
          <div v-else-if="col.columnName === 'use_corp'">
            <div v-if="scope.row.use_corp == 0">否</div>
            <div v-if="scope.row.use_corp == 1">是</div>
          </div>
          <div v-else-if="col.columnName === 'extra'">
            <div v-if="scope.row.extra.length <= 25">{{scope.row.extra}}</div>
            <el-popover v-else placement="top-end" width="200" trigger="hover" :content="scope.row.extra">
              <div slot="reference">{{scope.row.extra.slice(0,20)}}...</div>
            </el-popover>
          </div>
          <div v-else-if="col.columnName === 'moreover'">
            <div v-if=" scope.row.express_info.length > 0">
              <el-tooltip placement="top" effect="light">
                <div slot="content">
                  <div v-for="express in scope.row.express_info" :key="express.express_id">
                    <div>快递单号：{{express.express_id}}</div>
                    <div>公司：{{express.company}}</div>
                    <div>扫描类型：{{express.scanType}}</div>
                    <div>扫描网点：{{express.scanSiteName}}</div>
                    <div>扫描时间：{{express.scanDate}}</div>
                    <div v-html="express.tracks"></div><br />
                  </div>
                </div>
                <div slot="">{{scope.row.moreover}}</div>
              </el-tooltip>
            </div>
            <div v-else>
              <div v-if="scope.row.moreover.length <= 25">
                <div slot="reference">{{scope.row.moreover}}</div>
              </div>
              <el-popover placement="top-end" width="200" trigger="hover" :content="scope.row.moreover" v-else>
                <div slot="reference">{{scope.row.moreover.slice(0, 20) + '...'}}</div>
              </el-popover>
            </div>
          </div>

          <div v-else-if="col.columnName === 'remark'">
            <span v-if="scope.row.remark" class="underline fc-blue pointer" @click="editOrder(scope.$index)">
              {{scope.row.remark}}
            </span>
            <i v-else class="el-icon-edit" @click="editOrder(scope.$index)"></i>
          </div>

          <div v-else-if="col.columnName === 'status'">
            <div v-if="scope.row.status == 7">预售</div>
            <div v-if="scope.row.status == 6">拒绝</div>
            <div v-if="scope.row.status == 5">失效</div>
            <div v-if="scope.row.status == 4">已提现</div>
            <div v-if="scope.row.status == 3">返款中</div>
            <div v-if="scope.row.status == 2">完成订单</div>
            <div v-if="scope.row.status == 1">跟单中</div>
            <div v-if="scope.row.status == 0">报单</div>
          </div>

          <div v-else-if="col.columnName === 'purchase'">
            <div v-if="scope.row.purchase == 0">需要返现</div>
            <div v-if="scope.row.purchase == 1">直接折扣</div>
            <div v-if="scope.row.purchase == 2">假单</div>
            <div v-if="scope.row.purchase == 3">囤货</div>
            <div v-if="scope.row.purchase == 4">固返</div>
          </div>

          <div v-else-if="col.columnName === 'awid'" @dblclick="setFiltersValue('awid', scope.row.awid)">
            <div v-if="scope.row.awid !== 0">
              {{scope.row.watchword_title}}({{scope.row.awid}})
            </div>
          </div>

          <div v-else-if="col.columnName === 'ai_review_upload'">
            <div v-if="scope.row.ai_review_upload == 0">未审核</div>
            <div v-if="scope.row.ai_review_upload == 1">审核通过</div>
            <div v-if="scope.row.ai_review_upload == 2">需要人工校验</div>
            <div v-if="scope.row.ai_review_upload == 3">AI识别失败</div>
          </div>

          <div v-else-if="col.columnName === 'ai_review_finish'">
            <div v-if="scope.row.ai_review_finish == 0">未审核</div>
            <div v-if="scope.row.ai_review_finish == 1">审核通过</div>
            <div v-if="scope.row.ai_review_finish == 2">需要人工校验</div>
            <div v-if="scope.row.ai_review_finish == 3">AI识别失败</div>
          </div>

          <div v-else-if="col.columnName === 'etid'" @dblclick="setFiltersValue('etid', scope.row.etid)">
            <div v-if="scope.row.etid !== 0">
              {{scope.row.et_title}}({{scope.row.etid}})
            </div>
          </div>

          <div v-else-if="col.columnName === 'cdid'" @dblclick="setFiltersValue('cdid', scope.row.cdid)">
            <div v-if="scope.row.cdid !== 0">
              {{scope.row.docking_name}}({{scope.row.cdid}})
            </div>
          </div>

          <div v-else-if="col.columnName === 'docking_status'">
            <div v-if="scope.row.docking_status == 7">上报拒绝</div>
            <div v-if="scope.row.docking_status == 6">
              <el-tooltip class="item" effect="light" placement="top-end">
                <div slot="content">{{scope.row.docking_response.message}}</div>
                <div>上报失败</div>
              </el-tooltip>
            </div>
            <div v-if="scope.row.docking_status == 5">兑换成功</div>
            <div v-if="scope.row.docking_status == 4">代提现</div>
            <div v-if="scope.row.docking_status == 3">上报完成图</div>
            <div v-if="scope.row.docking_status == 2">上报成功</div>
            <div v-if="scope.row.docking_status == 1">准备上报</div>
            <div v-if="scope.row.docking_status == 0">不需要</div>
          </div>

          <div v-else-if="['create_time','last_edit'].includes(col.columnName)"
               v-html="formatTimeStamp(scope.row[col.columnName])"></div>

          <span v-else>{{ scope.row[col.columnName] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right" v-if="filters.status === -1">
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini" @click="editOrder(scope.$index)" v-if="scope.row.status !== 5 ">修改订单</el-button>
        </template>
      </el-table-column>
      <!-- 操作列 -->
      <el-table-column label="操作" width="160" fixed="right" align="center"  v-if="filters.status !== -1">
        <template slot-scope="scope">
          <div v-if="(filters.status == 0 || filters.status == 1 || filters.status == 2 || filters.status == 3 || filters.status === 7) && !reviseSelect" @dblclick="handleRadioChange(scope.$index)">
              <el-radio-group v-model="scope.row.isChoose">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="0">拒绝</el-radio>
              </el-radio-group>
          </div>
          <div v-if="reviseSelect">
            <el-checkbox v-model="scope.row.isCheck" @change="handleCheckedOrderChange">修改</el-checkbox>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-10 pb-36">
    </el-pagination>
    <!-- ✅ 你要的 表格列设置组件 -->
    <TableColumnSetting
      :visible.sync="isShowColumn"
      :column-list.sync="tableColumns"
      :default-columns="defaultColumns"
      :storage-key="`${$options.name}_table_columns_v2`"
    />
    <el-dialog title="批量修改" :visible.sync="multiReviseDialog" size="tiny" width="70%" style="margin-top: -5% !important" center>
      <el-form ref="form" :model="multiReviseInfo" label-width="100px">
        <el-form-item label="订单ID集合">
          <el-input v-model="multiReviseInfo.oids" class="dataForm__input" disabled="true">
          </el-input>
        </el-form-item>
        <div class="dataForm__item">
          <el-form-item label="活动名称">
            <el-select placeholder="请选择" v-model="multiReviseInfo.adid" disabled="true">
              <el-option v-for="item in adLists" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟单人">
            <el-select class="filter__input" size="medium" v-model="multiReviseInfo.opid" placeholder="不选不更改">
              <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists.slice(1)" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="dataForm__item" v-if="[2].includes(opid)">
          <el-form-item label="广告折扣">
            <el-input v-model="multiReviseInfo.aver_discount" placeholder="不填不更改">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考广告折扣" class="ml-20">
            <el-input v-model="multiReviseInfo.old_aver_discount" class="dataForm__input" disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="底价折扣">
            <el-input v-model="multiReviseInfo.min_discount" placeholder="不填不更改">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考底价折扣" class="ml-20">
            <el-input v-model="multiReviseInfo.old_min_discount" class="dataForm__input" disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="折扣">
            <el-input v-model="multiReviseInfo.discount" placeholder="不填不更改">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考折扣" class="ml-20">
            <el-input v-model="multiReviseInfo.old_discount" class="dataForm__input" disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="用户折扣">
            <el-input v-model="multiReviseInfo.user_discount" placeholder="不填不更改">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考用户折扣" class="ml-20">
            <el-input v-model="multiReviseInfo.old_user_discount" class="dataForm__input" disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="金额">
            <el-input v-model="multiReviseInfo.payment" placeholder="不填不更改">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考金额" class="ml-20">
            <el-input v-model="multiReviseInfo.old_payment" class="dataForm__input" disabled="true">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="实付价">
            <el-input v-model="multiReviseInfo.final_payment" placeholder="不填不更改">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考实付价" class="ml-20">
            <el-input v-model="multiReviseInfo.old_final_payment" class="dataForm__input" disabled="true">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="拍手费">
            <el-input v-model="multiReviseInfo.agency_fees" placeholder="不填不更改">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考拍手费" class="ml-20">
            <el-input v-model="multiReviseInfo.old_agency_fees" class="dataForm__input" disabled="true">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="额外信息">
            <el-input type="textarea" :rows="2" class="dataForm__input" v-model="multiReviseInfo.extra" size="mini" placeholder="不填不更改"></el-input>
          </el-form-item>
          <el-form-item label="快递信息">
            <el-input type="textarea" :rows="2" class="dataForm__input" v-model="multiReviseInfo.moreover" size="mini" placeholder="不填不更改"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="2" class="dataForm__input" v-model="multiReviseInfo.remark" size="mini" placeholder="不填不更改"></el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="对接状态" class="mr-20">
            <dockingStatusSelect v-model="multiReviseInfo.docking_status" />
          </el-form-item>
          <el-form-item label="AI报单图识别" class="mr-20">
            <aiReviewUploadSelect v-model="multiReviseInfo.ai_review_upload" />
          </el-form-item>
          <el-form-item label="AI完成图识别">
            <aiReviewFinishSelect v-model="multiReviseInfo.ai_review_finish" />
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="订单状态">
            <orderStatusSelect v-model="multiReviseInfo.status" />
          </el-form-item>
          <el-form-item label="是否对公" class="mr-20">
            <orderUseCorpSelect v-model="multiReviseInfo.use_corp" />
          </el-form-item>
        </div>
        <div class="flex jcc mt-30">
          <div class="blue-large-btn mr-20" @click="orderMultiRevise">保存</div>
          <div class="gray-large-btn" @click="multiReviseDialog = false">取消</div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="批量修改收款备注" :visible.sync="multiReceiveDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item"> 格式:广告名,订单ID,收款,收款备注,请款,请款备注（第一行标题，第二行数据开始）</div>
          <el-upload
            class="upload-demo"
            drag
            action=""
            :limit="1"
            accept=".xls,.xlsx"
            :http-request="adOrderMultiReceiveUpdate"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
            <div class="el-upload__tip fc-red" slot="tip" v-if="multiReceiveErrorOid != ''">错误订单ID: {{multiReceiveErrorOid}}</div>
          </el-upload>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="修改订单" :visible.sync="orderDialog" size="tiny" width="80%" height="80%" style="margin-top: -5% !important" center>
      <el-form ref="form" :model="orderInfo" label-width="100px">
        <div class="dataForm__item">
          <el-form-item label="ID">
            <el-input v-model="orderInfo.oid" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="活动名称">
            <el-select placeholder="请选择" v-model="orderInfo.adid" disabled="true">
              <el-option v-for="item in adLists" :key="item.value" :label="item.title" :value="item.adid"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="订单号">
            <el-input v-model="orderInfo.orderid" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="orderInfo.username" disabled="true">
                <template slot="prepend">({{orderInfo.uid}})</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="跟单人">
            <el-select v-model="orderInfo.opid" size="mini">
              <el-option v-for="item in operLists.slice(1)" :key="item.opid" :label="item.nickname" :value="item.opid"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务墙">
            <taskSelect v-model="orderInfo.etid" :lists.sync="taskLists" :need-edit="true"/>
          </el-form-item>
        </div>
        <el-form-item label="购买类型">
          <el-radio-group v-model="orderInfo.purchase">
            <div class="dib mr-20">
              <el-radio :label="0">需要返款</el-radio>
              <el-radio :label="1">直接折扣</el-radio>
              <el-radio :label="2">假单</el-radio>
              <el-radio :label="3">囤货</el-radio>
              <el-radio :label="4">固返</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <div class="dataForm__item">
          <el-form-item label="底价折扣">
            <el-input v-model="orderInfo.min_discount" disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="折扣">
            <el-input v-model="orderInfo.discount">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="用户折扣">
            <el-input v-model="orderInfo.user_discount">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="金额">
            <el-input v-model="orderInfo.payment"></el-input>
          </el-form-item>
          <el-form-item label="实付金">
            <el-input v-model="orderInfo.final_payment"></el-input>
          </el-form-item>
          <el-form-item label="拍收费">
            <el-input v-model="orderInfo.agency_fees"></el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="预售截图">
            <div class="headimg-container relative" style="width:150px">
              <uploadHeadImage :url.sync="orderInfo.presale_img" :itype="5"></uploadHeadImage>
            </div>
          </el-form-item>
          <el-form-item label="报单截图">
            <div class="headimg-container relative" style="width:150px">
              <uploadHeadImage :url.sync="orderInfo.payment_img" :itype="5"></uploadHeadImage>
            </div>
          </el-form-item>
          <el-form-item label="完成截图">
            <div class="headimg-container relative" style="width:150px">
              <uploadHeadImage :url.sync="orderInfo.finish_img" :itype="5"></uploadHeadImage>
            </div>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="对接状态">
            <dockingStatusSelect v-model="orderInfo.docking_status" />
          </el-form-item>
          <el-form-item label="AI报单图识别">
            <aiReviewUploadSelect v-model="orderInfo.ai_review_upload" />
          </el-form-item>
          <el-form-item label="AI完成图识别">
            <aiReviewFinishSelect v-model="orderInfo.ai_review_finish" />
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="额外信息">
            <el-input type="textarea" :rows="2" v-model="orderInfo.extra" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递单号">
            <el-input type="textarea" :rows="2" v-model="orderInfo.moreover" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="2" v-model="orderInfo.remark" size="mini"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="状态">
            <el-radio-group v-model="orderInfo.status">
              <div class="dib mr-20">
                <el-radio :label="7">预售</el-radio>
                <el-radio :label="0">报单</el-radio>
                <el-radio :label="1">跟单中</el-radio>
                <el-radio :label="2">完成订单</el-radio>
                <el-radio :label="5">失效</el-radio>
                <el-radio :label="6">拒绝</el-radio>
              </div>
            </el-radio-group>
        </el-form-item>
        <div class="flex jcc mt-30">
          <div class="blue-large-btn mr-20" @click="adOrderEdit">保存</div>
          <div class="gray-large-btn" @click="orderDialog = false">取消</div>
        </div>
      </el-form>
    </el-dialog>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {adOrderLists, adOrderUpdate, downloadAdOrderLists, adOrderEdit, adOrderMultiReceiveUpdate, operLists, orderMultiRevise} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
import adSelect from '../../../components/data-select/adSelect.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
import watchSelect from '../../../components/data-select/watchSelect.vue'
import taskSelect from '../../../components/data-select/taskSelect.vue'
import chnDockingSelect from '../../../components/data-select/chnDockingSelect.vue'
import dockingStatusSelect from '../../../components/data-select/dockingStatusSelect'
import aiReviewSelect from '../../../components/data-select/aiReviewSelect'
import aiReviewUploadSelect from '../../../components/data-select/aiReviewUploadSelect'
import aiReviewFinishSelect from '../../../components/data-select/aiReviewFinishSelect'
import orderStatusSelect from '../../../components/data-select/orderStatusSelect'
import orderUseCorpSelect from '../../../components/data-select/orderUseCorpSelect'
export default {
  name: 'adOrder',
  mixins: [mixinList],
  components: {
    uploadHeadImage,
    adSelect,
    operSelect,
    taskSelect,
    watchSelect,
    chnDockingSelect,
    dockingStatusSelect,
    aiReviewSelect,
    aiReviewUploadSelect,
    aiReviewFinishSelect,
    orderStatusSelect,
    orderUseCorpSelect
  },
  data () {
    return {
      multipleSelection: [],
      isShowColumn: false,
      // 默认列配置
      defaultColumns: [
        { columnName: 'oid', columnTitle: 'ID', width: 60, isShow: true, isSum: false },
        { columnName: 'oper_nickname', columnTitle: '跟单人', width: 100, isShow: true, isSum: false },
        { columnName: 'adid', columnTitle: '广告', isShow: true, isSum: false },
        { columnName: 'uid', columnTitle: '用户', isShow: true, isSum: false },
        { columnName: 'orderid', columnTitle: '订单ID', width: 150, isShow: true, isSum: false },
        { columnName: 'nickname', columnTitle: '微信昵称', isShow: true, isSum: false },
        { columnName: 'payment', columnTitle: '金额', isShow: true, isSum: true },
        { columnName: 'final_payment', columnTitle: '实付金', isShow: true, isSum: true },
        { columnName: 'min_discount', columnTitle: '底价折扣', isShow: true, isSum: false },
        { columnName: 'use_corp', columnTitle: '对公', isShow: true, isSum: false },
        { columnName: 'discount', columnTitle: '项目折扣', isShow: true, isSum: false },
        { columnName: 'user_discount', columnTitle: '用户折扣', isShow: true, isSum: false },
        { columnName: 'commission', columnTitle: '佣金', isShow: true, isSum: true },
        { columnName: 'agency_fees', columnTitle: '拍手费', isShow: true, isSum: true },
        { columnName: 'presale_img', columnTitle: '预售截图', isShow: true, isSum: false },
        { columnName: 'payment_img', columnTitle: '报单截图', isShow: true, isSum: false },
        { columnName: 'finish_img', columnTitle: '完成截图', isShow: true, isSum: false },
        { columnName: 'extra', columnTitle: '额外信息', width: 100, isShow: true, isSum: false },
        { columnName: 'moreover', columnTitle: '快递单号', width: 100, isShow: true, isSum: false },
        { columnName: 'remark', columnTitle: '备注', isShow: true, isSum: false },
        { columnName: 'status', columnTitle: '状态', isShow: true, isSum: false },
        { columnName: 'purchase', columnTitle: '购买类型', isShow: true, isSum: false },
        { columnName: 'awid', columnTitle: '口令', isShow: true, isSum: false },
        { columnName: 'ai_review_upload', columnTitle: 'AI报单图审核', isShow: true, isSum: false },
        { columnName: 'ai_review_finish', columnTitle: 'AI完成图审核', isShow: true, isSum: false },
        { columnName: 'ai_address', columnTitle: 'AI识别地址', isShow: true, isSum: false },
        { columnName: 'etid', columnTitle: '任务墙', isShow: true, isSum: false },
        { columnName: 'cdid', columnTitle: '对接方', isShow: true, isSum: false },
        { columnName: 'docking_status', columnTitle: '对接状态', isShow: true, isSum: false },
        { columnName: 'create_time', columnTitle: '创建时间', width: 100, isShow: true, isSum: false },
        { columnName: 'last_edit', columnTitle: '编辑时间', width: 100, isShow: true, isSum: false },
        { columnName: 'mosaic_payment', columnTitle: '马赛克报单图', isShow: true, isSum: false },
        { columnName: 'mosaic_finish', columnTitle: '马赛克完成图', isShow: true, isSum: false },
        { columnName: 'apply', columnTitle: '请款金额', isShow: true, isSum: true },
        { columnName: 'apply_remark', columnTitle: '请款备注', isShow: true, isSum: false },
        { columnName: 'receive', columnTitle: '收款金额', isShow: true, isSum: true },
        { columnName: 'receive_remark', columnTitle: '收款备注', isShow: true, isSum: false },
        { columnName: 'sale_discount', columnTitle: '出货折扣', isShow: true, isSum: false },
        { columnName: 'exchange_time', columnTitle: '兑换时间', width: 100, isShow: true, isSum: false }
      ],
      tableColumns: [],
      opid: '',
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        dateTime: '',
        start_time: '',
        end_time: '',
        status: -1,
        adid: '',
        oids: '',
        orderid: '',
        uid: '',
        opids: [],
        awid: '',
        etid: '',
        min_payment: '',
        max_payment: '',
        cdid: '',
        docking_status: '',
        purchase: '',
        remark: '',
        apply_remark: '',
        receive_remark: '',
        addressee: '',
        download: '',
        phone: '',
        ai_review_status: '',
        invalid_uid_lists: '',
      },
      adLists: [],
      operLists: [],
      watchwordLists: [],
      taskLists: [],
      // 状态按钮
      statusList: [
        {
          name: '所有',
          value: -1,
          status: 1
        },
        {
          name: '预售',
          value: 7,
          status: 0
        },
        {
          name: '报单',
          value: 0,
          status: 0
        },
        {
          name: '跟单中',
          value: 1,
          status: 0
        },
        {
          name: '完成订单',
          value: 2,
          status: 0
        },
        {
          name: '提现中',
          value: 3,
          status: 0
        },
        {
          name: '已提现',
          value: 4,
          status: 0
        },
        {
          name: '失效',
          value: 5,
          status: 0
        },
        {
          name: '拒绝',
          value: 6,
          status: 0
        }
      ],
      purchaseList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '需要返款',
          value: 0
        },
        {
          name: '直接折扣',
          value: 1
        },
        {
          name: '假单',
          value: 2
        },
        {
          name: '囤货',
          value: 3
        },
        {
          name: '固返',
          value: 4
        }
      ],
      // 操作按钮
      handleList: [
        {
          name: '全部通过',
          value: 1,
          status: 0
        },
        {
          name: '全部拒绝',
          value: 2,
          status: 0
        }
      ],
      pickerOptions: {
        shortcuts: []
      },
      previewDialog: false, // 查看图片弹窗
      previewList: [], // 查看列表
      moreDisplay: false,
      reviseSelect: 0,
      checkAll: false,
      isIndeterminate: false,
      checkedCount: 0,
      multiReceiveDialog: false,
      multiReceiveErrorOid: '',
      orderDialog: false,
      orderInfo: {
        oid: '',
        orderid: '',
        nickname: '',
        adid: '',
        opid: '',
        etid: '',
        title: '',
        uid: '',
        purchase: '',
        username: '',
        min_discount: '',
        discount: '',
        user_discount: '',
        payment: '',
        final_payment: '',
        agency_fees: '',
        presale_img: '',
        payment_img: '',
        finish_img: '',
        extra: '',
        moreover: '',
        remark: '',
        docking_status: '',
        ai_review_upload: '',
        ai_review_finish: '',
        status: ''
      },
      multiReviseDialog: false,
      multiReviseInfo: {
        oids: '',
        adid: '',
        opid: '',
        old_aver_discount: '',
        old_min_discount: '',
        old_payment: '',
        old_final_payment: '',
        old_discount: '',
        old_user_discount: '',
        old_agency_fees: '',
        aver_discount: '',
        min_discount: '',
        payment: '',
        discount: '',
        final_payment: '',
        user_discount: '',
        agency_fees: '',
        extra: '',
        moreover: '',
        remark: '',
        docking_status: '',
        ai_review_upload: '',
        ai_review_finish: '',
        status: '',
        use_corp: ''
      }
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.dataTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.dataTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    getSelectionValue (key) {
      let lists = []

      this.multipleSelection.forEach(item => {
        lists.push(item[key])
      })

      return lists.join('|')
    },

    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    handleRadioChange (index) {
      this.lists[index].isChoose = ''
    },
    handleCheckAllChange (val) {
      this.lists.forEach((item) => {
        item.isCheck = val
        item.isChoose = ''
      })

      this.checkedCount = val ? this.lists.length : 0
      this.isIndeterminate = false
    },
    handleCheckedOrderChange (val) {
      this.checkedCount = this.checkedCount + (val ? 1 : -1)
      this.checkAll = this.checkedCount === this.lists.length
      this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.lists.length
    },
    previewURL (oid, status) {
      let images = []
      let initialViewIndex = 0
      this.lists.forEach((item) => {
        if (status === 0) {
          if (item.payment_img !== '') {
            images.push(item.payment_img)
          }
        } else if (status === 2) {
          if (item.finish_img !== '') {
            images.push(item.finish_img)
          }
        } else if (status === 3) {
          if (item.mosaic_payment !== '') {
            images.push(item.mosaic_payment)
          }
        } else if (status === 4) {
          if (item.mosaic_finish !== '') {
            images.push(item.mosaic_finish)
          }
        } else {
          if (item.presale_img !== '') {
            images.push(item.presale_img)
          }
        }

        if (item.oid === oid) {
          initialViewIndex = images.length - 1
        }
      })

      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: initialViewIndex
        },
        images: images
      })
    },
    getSummaries (param) {
      return util.getSummaries(param, this.defaultColumns, 1)
    },
    getMonthList () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1

      for (let i = 0; i < 12; i++) {
        let monthStr = (month > 9) ? month.toString() : ('0' + month)
        let yearMonth = year.toString() + '-' + monthStr

        let nextMonth = new Date(year, month, 1, 0, 0, 0)
        nextMonth = nextMonth.setDate(nextMonth.getDate() - 1)

        if (month === 1) {
          year = year - 1
          month = 12
        } else {
          month = month - 1
        }

        let currentMonth = new Date(year, month, 1, 0, 0, 0)

        this.pickerOptions['shortcuts'].push({
          text: yearMonth,
          onClick (picker) {
            const end = new Date(nextMonth)
            const start = new Date(currentMonth)
            picker.$emit('pick', [start, end])
          }
        })
      }
    },
    getOperLists () {
      let params = {
        market: 3,
        status: 1,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid
            }
          })
          this.operLists.unshift({
            nickname: '所有',
            opid: ''
          })
        }
      })
    },
    changeFilters () {
      this.filters.p = 1

      this.getList()
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.status !== -1) {
        params.status = filters.status
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      if (filters.orderid !== '') {
        params.orderid = filters.orderid
      }
      if (filters.uid !== '') {
        params.uid = filters.uid
      }
      if (filters.invalid_uid_lists !== '') {
        params.invalid_uid_lists = filters.invalid_uid_lists
      }
      if (filters.opids.length !== 0) {
        params.opids = filters.opids.join(',')
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.etid !== '') {
        params.etid = filters.etid
      }
      if (filters.purchase !== '') {
        params.purchase = filters.purchase
      }
      if (filters.addressee !== '') {
        params.addressee = filters.addressee
      }
      if (filters.phone !== '') {
        params.phone = filters.phone
      }
      if (filters.oids !== '') {
        params.oids = filters.oids
      }
      if (filters.min_payment !== '') {
        params.min_payment = filters.min_payment
      }
      if (filters.max_payment !== '') {
        params.max_payment = filters.max_payment
      }
      if (filters.cdid !== '') {
        params.cdid = filters.cdid
      }
      if (filters.docking_status !== '') {
        params.docking_status = filters.docking_status
      }
      if (filters.ai_review_status !== '') {
        if (filters.ai_review_status < 10) {
          params.ai_review_upload = filters.ai_review_status
        } else {
          params.ai_review_finish = filters.ai_review_status - 10
        }
      }
      if (filters.remark !== '') {
        params.remark = filters.remark
      }
      if (filters.apply_remark !== '') {
        params.apply_remark = filters.apply_remark
        if (params.apply_remark === 'null') {
          params.apply_remark = ''
        }
      }
      if (filters.receive_remark !== '') {
        params.receive_remark = filters.receive_remark
        if (params.receive_remark === 'null') {
          params.receive_remark = ''
        }
      }
      if (this.reviseSelect) {
        params.consistent = 1
      }
      this.listLoading = true
      adOrderLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
            item.isCheck = false
          })
          this.checkAll = false
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    changeMulti () {
      this.reviseSelect = this.reviseSelect ^ 1
      this.isIndeterminate = false
      this.filters.p = 1
      this.getList()

      this.handleList.forEach(item => {
        item.status = 0
      })
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      // this.getList()
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value
      this.filters.p = 1
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.getList()
    },
    adOrderUpdate () {
      let lists = this.lists
      let accept = []
      let reject = []
      let consistent = []
      lists.forEach((item) => {
        if (item.isChoose === 1) {
          accept.push(item.oid)
        }
        if (item.isChoose === 0) {
          reject.push(item.oid)
        }
        if (item.isCheck === true) {
          consistent.push(item.oid)
        }
      })

      let params = {
        accept: accept.join('|'),
        reject: reject.join('|'),
        consistent: consistent.join('|')
      }

      adOrderUpdate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    download (choose) {
      let filters = this.filters
      let link = downloadAdOrderLists + '?choose=' + choose

      if (filters.adid === '' && filters.start_time === '' && filters.awid === '' && filters.etid === '') {
        this.$notify({
          title: '失败',
          message: '请先选择活动、或者时间、或者口令、或者任务',
          type: 'error'
        })
        return
      }

      if (filters.adid !== '') {
        link = link + '&adid=' + filters.adid
      }
      if (filters.uid !== '') {
        link = link + '&uid=' + filters.uid
      }
      if (filters.opids.length !== 0) {
        link = link + '&opids=' + filters.opids.join(',')
      }
      if (filters.oids !== '') {
        link = link + '&oids=' + filters.oids
      }
      if (filters.purchase !== '') {
        link = link + '&purchase=' + filters.purchase
      }
      if (filters.start_time !== '') {
        link = link + '&start_time=' + filters.start_time
      }
      if (filters.end_time !== '') {
        link = link + '&end_time=' + filters.end_time
      }
      if (filters.awid !== '') {
        link = link + '&awid=' + filters.awid
      }
      if (filters.etid !== '') {
        link = link + '&etid=' + filters.etid
      }
      if (filters.status !== -1) {
        link = link + '&status=' + filters.status
      }
      if (filters.orderid !== '') {
        link = link + '&orderid=' + filters.orderid
      }
      if (filters.remark !== '') {
        link = link + '&remark=' + filters.remark
      }
      if (filters.cdid !== '') {
        link = link + '&cdid=' + filters.cdid
      }
      if (filters.docking_status !== '') {
        link = link + '&docking_status=' + filters.docking_status
      }
      if (filters.ai_review_status !== '') {
        if (filters.ai_review_status < 10) {
          link = link + '&ai_review_upload=' + filters.ai_review_status
        } else {
          let ai_review_finish = filters.ai_review_status - 10
          link = link + '&ai_review_finish=' + ai_review_finish
        }
      }
      if (filters.invalid_uid_lists !== '') {
        link = link + '&invalid_uid_lists=' + filters.invalid_uid_lists
      }
      window.open(link, 'a')
    },
    changeHandle (index) {
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.handleList[index].status = 1
      switch (this.handleList[index].value) {
        case 1: // 全部通过
          this.lists.forEach((item) => {
            item.isChoose = 1
            item.isCheck = false
          })
          break
        case 2: // 全部拒绝
          this.lists.forEach((item) => {
            item.isChoose = 0
            item.isCheck = false
          })
          break
      }
    },
    dateTimeChange () {
      this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
      this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
    },
    adOrderEdit () {
      let params = this.orderInfo

      adOrderEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.orderDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    orderMultiRevise () {
      let params = {
        oids: this.multiReviseInfo.oids,
        adid: this.multiReviseInfo.adid
      }

      for (let key of ['opid', 'aver_discount', 'min_discount', 'payment', 'discount', 'final_payment', 'user_discount', 'agency_fees', 'extra', 'moreover', 'remark', 'docking_status', 'ai_review_upload', 'ai_review_finish', 'status', 'use_corp']) {
        if (this.multiReviseInfo[key] !== '') {
          params[key] = this.multiReviseInfo[key]
        }
      }

      orderMultiRevise(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.multiReviseDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    editMultiReviseOrder () {
      let oids = this.getSelectionValue('oid')

      let content = ''

      if (oids === '') {
        content = '请选择需要上报的订单'
      }

      if (this.filters.adid === '') {
        content = '请选择需要广告'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      this.multiReviseDialog = true

      for (let key in this.multiReviseInfo) {
        this.multiReviseInfo[key] = ''
      }

      this.multiReviseInfo['adid'] = this.filters.adid
      this.multiReviseInfo['oids'] = oids
      this.multiReviseInfo['old_opid'] = this.getSelectionValue('opid')
      this.multiReviseInfo['old_aver_discount'] = this.getSelectionValue('aver_discount')
      this.multiReviseInfo['old_min_discount'] = this.getSelectionValue('min_discount')
      this.multiReviseInfo['old_discount'] = this.getSelectionValue('discount')
      this.multiReviseInfo['old_payment'] = this.getSelectionValue('payment')
      this.multiReviseInfo['old_final_payment'] = this.getSelectionValue('final_payment')
      this.multiReviseInfo['old_user_discount'] = this.getSelectionValue('user_discount')
      this.multiReviseInfo['old_agency_fees'] = this.getSelectionValue('agency_fees')
    },
    adOrderMultiReceiveUpdate (params) {
      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      adOrderMultiReceiveUpdate(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.multiReceiveDialog = false
        } else {
          this.multiReceiveErrorOid = data.oid
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    editOrder (index) {
      this.orderDialog = true
      for (let key in this.orderInfo) {
        this.orderInfo[key] = this.lists[index][key]
      }
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))
    this.getMonthList()
    let adid = parseInt(this.$route.query.adid || 0)
    let uid = parseInt(this.$route.query.uid || 0)
    let oids = this.$route.query.oids || ''
    if (adid) {
      this.filters.adid = adid
    }
    if (oids) {
      this.filters.oids = oids
    }
    if (uid) {
      this.filters.uid = uid
    }
    this.getOperLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.dateTime': 'dateTimeChange',
    'filters.adid': 'changeFilters',
    'filters.oids': 'changeFilters',
    'filters.orderid': 'changeFilters',
    'filters.start_time': 'changeFilters',
    'filters.uid': 'changeFilters',
    'filters.purchase': 'changeFilters',
    'filters.opids': 'changeFilters',
    'filters.min_payment': 'getList',
    'filters.max_payment': 'getList',
    'filters.awid': 'changeFilters',
    'filters.etid': 'changeFilters',
    'filters.cdid': 'changeFilters',
    'filters.docking_status': 'changeFilters',
    'filters.apply_remark': 'changeFilters',
    'filters.receive_remark': 'changeFilters',
    'filters.ai_review_status': 'changeFilters',
    'filters.invalid_uid_lists': 'changeFilters'
  }
}
</script>
<style scoped>
/deep/ .el-table .el-table__cell {
  padding: 10px 0px;
}

/* 修改单元格内容的 padding */
/deep/ .el-table .cell {
  padding: 0px 6px; /* 上下0，左右6px */
}
.payment_range {
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  outline: 0;
  padding: 0 15px;
  width: 80px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
/* 子项：自动平分剩余宽度，所有项一样宽 */
.dataForm__item .el-form-item {
  width: 400px !important; /* 固定300px，核心 */
}

.dataForm__input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/module/ad/adOrder.vue